import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { resources } from './locales';

/**
 * Keeps <html lang> equal to the language the UI is showing (public/index.html
 * hardcodes "en"), so browsers and translators see the real source language.
 * Registered before init so the first detection is applied too.
 */
i18n.on('languageChanged', (language: string) => {
  // resolvedLanguage is the language the UI actually renders (en or fi), unlike a
  // detected 'sv-SE' that falls back to English.
  document.documentElement.lang = (i18n.resolvedLanguage || language).split('-')[0];
});

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources, // Add the imported resources here
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false // React already safes from XSS
    },
    detection: {
      // No 'cookie' lookup: nothing here writes that cookie (caches is empty), and the
      // detector reads document.cookie without a guard, which throws in sandboxed frames.
      order: ['localStorage', 'navigator', 'htmlTag', 'path'],
      caches: [], // Set to empty array to disable caching
    }
  });

export default i18n;